"use strict";

exports.__esModule = true;
var TABLET_WIDTH = exports.TABLET_WIDTH = 768;
var MOBILE_LARGE_WIDTH = exports.MOBILE_LARGE_WIDTH = 425;
var MOBILE_CALENDAR_DAYS = exports.MOBILE_CALENDAR_DAYS = 3;
var TABLET_CALENDAR_DAYS = exports.TABLET_CALENDAR_DAYS = 5;
var LAPTOP_CALENDAR_DAYS = exports.LAPTOP_CALENDAR_DAYS = 7;
var NEAREST_AVAILABILITY_END_DAYS = exports.NEAREST_AVAILABILITY_END_DAYS = 100;